/**
 * Display formatters for task rows.
 *
 * Extracted verbatim from the pre-SDataTable `TasksViewRow` so the migration to
 * the standard table changed presentation only — the numbers and date strings a
 * user sees are byte-identical to before.
 */

/** `14:22` for today, `Aug 3 21:41` otherwise, `—` when there is no date. */
export function formatTimestamp(date: Date | undefined | null): string {
  if (!date || !(date instanceof Date)) return '—';
  const now = new Date();
  const isToday = date.toDateString() === now.toDateString();
  const time = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  if (isToday) return time;
  return `${date.toLocaleDateString([], { month: 'short', day: 'numeric' })} ${time}`;
}

/** Minor units → localized currency, `—` when absent. */
export function formatMoneyMinor(amountMinor: number | undefined, currency = 'usd'): string {
  if (amountMinor === undefined || !Number.isFinite(amountMinor)) return '—';
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currency.toUpperCase(),
  }).format(amountMinor / 100);
}

/**
 * Elapsed time in ms between task start and its last update (or now, while the
 * task is still running). `null` when `createdAt` is missing.
 */
export function getTaskDurationMs(
  createdAt: Date | undefined | null,
  updatedAt: Date | undefined | null,
): number | null {
  if (!createdAt || !(createdAt instanceof Date)) return null;
  const end = updatedAt instanceof Date ? updatedAt : new Date();
  return end.getTime() - createdAt.getTime();
}

/** `<1s` / `42s` / `6m 12s`. */
export function formatDurationMs(diffMs: number | null): string {
  if (diffMs === null) return '—';
  if (diffMs < 1000) return '<1s';
  const secs = Math.floor(diffMs / 1000);
  if (secs < 60) return `${secs}s`;
  const mins = Math.floor(secs / 60);
  return `${mins}m ${secs % 60}s`;
}
